var _path, _g, _g2, _g3, _g4, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1368,
    height: 285,
    viewBox: "0 0 1368 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 198.492C0.5 198.492 170.346 241.24 310 235.992C385.965 233.137 421.006 229.423 494.5 209.992C566.383 190.987 585 153.992 667.5 130.492C773.723 100.235 894 153.992 894 153.992C894 153.992 1140.74 264.542 1286.5 130.492C1342.5 78.9922 1342.5 8.99219 1342.5 8.99219",
    stroke: "url(#paint0_linear_8204_320)",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_8204_320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 235.492C14 235.492 183.846 278.24 323.5 272.992C399.465 270.137 434.506 266.423 508 246.992C579.883 227.987 598.5 190.992 681 167.492C787.223 137.235 907.5 190.992 907.5 190.992C907.5 190.992 1154.24 301.542 1300 167.492C1356 115.992 1356 45.9922 1356 45.9922",
    stroke: "url(#paint1_linear_8204_320)",
    strokeWidth: 3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_8204_320)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 215.992,
    r: 7,
    fill: "#3C73FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 215.992,
    r: 12.5,
    stroke: "white",
    strokeWidth: 11
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_8204_320)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 208.992,
    r: 7,
    fill: "#3C73FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 208.992,
    r: 12.5,
    stroke: "white",
    strokeWidth: 11
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_8204_320)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 891,
    cy: 152.992,
    r: 7,
    fill: "#3C73FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 891,
    cy: 152.992,
    r: 12.5,
    stroke: "white",
    strokeWidth: 11
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1329.86 38.6604L1342.64 1.07055L1348.85 39.3022L1339.68 29.4867L1329.86 38.6604Z",
    fill: "#3C73FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8204_320",
    x: 3.63672,
    y: 35.9917,
    width: 1363.86,
    height: 248.947,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_8204_320"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_8204_320",
    x: 74,
    y: 187.992,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.233333 0 0 0 0 0.450556 0 0 0 0 1 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8204_320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8204_320",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_8204_320",
    x: 454,
    y: 180.992,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.233333 0 0 0 0 0.450556 0 0 0 0 1 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8204_320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8204_320",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_8204_320",
    x: 853,
    y: 124.992,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.233333 0 0 0 0 0.450556 0 0 0 0 1 0 0 0 0.73 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8204_320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8204_320",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8204_320",
    x1: 1,
    y1: 119.208,
    x2: 1342.5,
    y2: 119.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C73FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#3C73FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8204_320",
    x1: 21.8563,
    y1: 265.173,
    x2: 1356.71,
    y2: 265.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C73FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3C73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3C73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C73FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWave);
export default __webpack_public_path__ + "static/media/BlueWave.fd824bdc13b4b29cec7a4268fd261893.svg";
export { ForwardRef as ReactComponent };